import { getCollectionReducer } from '@framework/state/Redux/collectionFactory';
import actionTypes from './actionTypes';

export default getCollectionReducer(actionTypes);
